module.exports = __webpack_public_path__ + "img/-icon.93b16cd.png";